<div class="third-party-fields-container">
    <div class="addresseeName-container">
        <!-- Address name -->
        <mm-text-input-control class="big-bottom-spacer" id="checkTransactionDetails_addresseeName"
            [parentForm]="parentForm" [inputControlModel]="addresseeNameModel" [errorMessage]="addresseeNameError">
        </mm-text-input-control>

        <!-- Address name continued -->
        <mm-text-input-control class="big-bottom-spacer" id="checkTransactionDetails_addresseeNameCont"
            [parentForm]="parentForm" [inputControlModel]="addresseeNameContModel">
        </mm-text-input-control>

        <!-- Address name continued -->
        <mm-text-input-control [ngClass]="addresseeNameCont2Class" id="checkTransactionDetails_addresseeNameCont2"
            [parentForm]="parentForm" [inputControlModel]="addresseeNameCont2Model">
        </mm-text-input-control>

        <!-- Third addressee line banner for create standing auth -->
        <mm-banners *ngIf="showThirdAddresseeInfoBanner" data-testid="thirdAddresseeNameInfoBanner" [type]="'information'"
        [bannerText]="[createSaThirdAddresseeNameInfoText]"></mm-banners>
    </div>
</div>

<div class="address-container">
    <div class="address-input">
        <!-- Street address -->
        <mm-text-input-control class="big-bottom-spacer" id="checkTransactionDetails_streetAddress"
            [parentForm]="parentForm" [inputControlModel]="streetAddressModel" [errorMessage]="streetAddressError">
        </mm-text-input-control>

        <!-- Street address continued -->
        <mm-text-input-control class="big-bottom-spacer" id="checkTransactionDetails_streetAddressCont"
            [parentForm]="parentForm" [inputControlModel]="streetAddressContModel">
        </mm-text-input-control>
    </div>
</div>